export default function(instance){
    return{
        Commit(payload){
            return instance.put("/CompanyBrand/Commit", payload);
        },
    }
}
